import { Flex } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

export const PostCardContent = styled(Flex)<LayoutProps & SpaceProps>`
  border-radius: ${tokens.radii.m};
  overflow: hidden;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  height: 588px;
  margin: 0 auto;
  max-width: 570px;

  ${layout};
  ${space};

  ${tokens.mediaQueries.s} {
    height: 426px;
  }
`;

export const PostCardThumbnail = styled.div`
  height: 302px;
  flex-shrink: 0;
  background-size: cover;

  ${tokens.mediaQueries.s} {
    height: 218px;
  }
`;

export const PostCardDetails = styled(Flex)`
  height: 100%;
  padding: 40px ${tokens.space.large};

  ${tokens.mediaQueries.s} {
    padding: ${tokens.space.smaller} ${tokens.space.large} 20px;
  }
`;

export const PostCardTitle = styled.h1`
  font-family: ${tokens.font.family.ifood.body};
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 42px;
  color: ${tokens.colors.black};

  ${tokens.mediaQueries.s} {
    font-weight: 300;
    font-size: ${tokens.fontSizes.l};
    line-height: ${tokens.lineHeights.l};
  }
`;

export const PostCardLink = styled.span`
  font-size: ${tokens.fontSizes.m};
  line-height: ${tokens.lineHeights.l};
  color: ${tokens.colors.primary};
  text-decoration: underline;
  padding-right: ${tokens.space.regular};
  display: flex;
  align-items: center;
`;

export const PostCardWrapperLink = styled.a`
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;
